import { Box, Typography } from '@mui/material';
import { OptionRow } from './components/OptionRow';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined, RemoveCircleOutline } from '@mui/icons-material';
import { SifOption } from 'ui-component/records/ImportDialogs/types';
import { useState } from 'react';
import { ObjectProperty } from 'views/backoffice/CustomObjects/types';

export const OptionBox = ({
    option,
    handleChangeOption,
    handleDeleteOption,
    properties
}: {
    option: SifOption;
    handleChangeOption: (option: SifOption) => void;
    handleDeleteOption: (optionId: number) => void;
    properties: ObjectProperty[];
}) => {
    const [isOpenBox, setIsOpenBox] = useState(true);
    const filteredKeys = Object.keys(option).filter((key) => properties?.some((property) => property.name === key));
    return (
        <Box sx={{ color: '#858585' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    mb: '12px'
                }}
            >
                {isOpenBox && (
                    <KeyboardArrowUpOutlined
                        sx={{ bgcolor: '#f5f6f7', borderRadius: '100%', fontSize: '30px', cursor: 'pointer' }}
                        onClick={() => setIsOpenBox(false)}
                    />
                )}
                {!isOpenBox && (
                    <KeyboardArrowDownOutlined
                        sx={{ bgcolor: '#f5f6f7', borderRadius: '100%', fontSize: '30px', cursor: 'pointer' }}
                        onClick={() => setIsOpenBox(true)}
                    />
                )}
                <Typography flexGrow={1} sx={{ borderLeft: '1px solid #D9D9D9', p: '8px' }}>
                    {`Options - ${option.tempId || ''}`}
                </Typography>
                <RemoveCircleOutline
                    sx={{ bgcolor: '#f5f6f7', borderRadius: '100%', cursor: 'pointer' }}
                    onClick={() => handleDeleteOption(Number(option.tempId))}
                />
            </Box>
            <Box width="86%" ml="auto" sx={{ display: isOpenBox ? 'flex' : 'none', flexDirection: 'column', gap: '12px' }}>
                {filteredKeys
                    ?.filter((key) => !['id', 'tempId'].includes(key))
                    .map((key) => (
                        <OptionRow
                            label={key}
                            value={option[key as keyof SifOption] as string}
                            onChangeOption={(newValue: string) => handleChangeOption({ ...option, [key]: newValue })}
                        />
                    ))}
            </Box>
        </Box>
    );
};
